import {
  TEMPLATE_FETCH_ALL_SMS_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_SMS_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_SMS_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_SMS_TEMPLATE_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function fetchAllSmsTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_SMS_TEMPLATE_BEGIN,
    });
    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=SMS`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_SMS_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_SMS_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function dismissFetchAllSmsTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_SMS_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_SMS_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllSmsTemplatePending: true,
        fetchAllSmsTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllSmsTemplatePending: false,
        fetchAllSmsTemplateError: null,
        smsTemplates: action.data,
        template: null,
      };

    case TEMPLATE_FETCH_ALL_SMS_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllSmsTemplatePending: false,
        fetchAllSmsTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_SMS_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllSmsTemplateError: null,
      };

    default:
      return state;
  }
}
